import { AI_ANALYTICS } from '../../../constants/accessToPages';
import { AI_ANALYTICS_PATH } from '../../../constants/aiAnalytics';

import SemanticModelPage from './components/SemanticModelPage';
import AiAnalyticsChat from './AiAnalyticsChat';
import { SEMANTIC_MODEL_PATH } from './aiAnalyticsConstants';

export const aiAnalyticsRouterConfig = [
  {
    name: 'AI Analytics',
    path: AI_ANALYTICS_PATH,
    component: AiAnalyticsChat,
    access: [AI_ANALYTICS],
    feature: 'aiAnalyticsEnabled'
  },
  {
    name: 'AI Semantic Model',
    path: SEMANTIC_MODEL_PATH,
    component: SemanticModelPage,
    access: [AI_ANALYTICS],
    feature: 'aiAnalyticsEnabled'
  }
];
